<template>
  <div class="enterprise-content">
    <div class="toolbar">
      <el-input
        v-model="searchQuery"
        placeholder="搜索用户信息..."
        style="width: 300px"
        @input="filterData"
        clearable
      >
        <template #prefix>
          <el-icon><Search /></el-icon>
        </template>
      </el-input>
      <el-button type="primary" @click="showAddModal">新增用户</el-button>
    </div>

    <el-table :data="filteredList" style="width: 100%" border>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="用户信息"></el-table-column>
      <el-table-column prop="email" label="邮箱"></el-table-column>
      <el-table-column prop="password" label="密码"></el-table-column> 
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editItem(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      v-model="showModal"
      :title="isEditing ? '编辑用户信息' : '新增用户'"
      width="500px"
    >
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="用户信息" prop="name">
          <el-input v-model="formData.name" placeholder="请输入用户信息"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="formData.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="formData.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closeModal">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Search } from '@element-plus/icons-vue'
import { getUserList } from '@/api/index'

export default {
  name: 'EnterprisePage',
  components: {
    Search
  },
  data() {
    return {
      searchQuery: '',
      showModal: false,
      isEditing: false,
      list: [],
      filteredList: [],
      formData: {
        id: null,
        name: '',
        email: '',
        password: '', 
      },
      rules: {
        name: [
          { required: true, message: '请输入用户信息', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const res = await getUserList()
        console.log('getUserList--->', res)
        this.list = res.data.list || []
        this.filteredList = [...this.list]
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      }
    },
    filterData() {
      if (!this.searchQuery) {
        this.filteredList = [...this.list]
      } else {
        this.filteredList = this.list.filter(item => 
          item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      }
    },
    showAddModal() {
      this.isEditing = false
      this.formData = {
        id: null,
        name: '',
        email: '',
        password: '',
        rember: '',
        address: '',
        status: 'active'
      }
      this.showModal = true
    },
    editItem(item) {
      this.isEditing = true
      this.formData = { ...item }
      this.showModal = true
    },
    deleteItem(id) {
      this.$confirm('确定要删除这条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.list = this.list.filter(item => item.id !== id)
        this.filterData()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.isEditing) {
            const index = this.list.findIndex(item => item.id === this.formData.id)
            if (index !== -1) {
              this.list[index] = { ...this.formData }
            }
          } else {
            const newId = Math.max(...this.list.map(item => item.id), 0) + 1
            this.list.push({ ...this.formData, id: newId })
          }
          this.filterData()
          this.closeModal()
          this.$message({
            type: 'success',
            message: this.isEditing ? '编辑成功!' : '新增成功!'
          })
        }
      })
    },
    closeModal() {
      this.showModal = false
      this.formData = {
        id: null,
        name: '',
        email: '',
        password: '',
        rember: '',
        address: '',
        status: 'active'
      }
    }
  }
}
</script>

<style scoped>
.enterprise-content {
  height: 100%;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}
</style>
